// Private
import Processes from "../cultura/views/Processes.vue";
import ProcessDetail from "../cultura/views/ProcessDetail.vue";

// Public
import Survey from "./views/Survey.vue";
import ShareCultura from "./views/ShareCultura.vue";

export default [
  {
    path: "/cultura",
    component: Processes,
    menu: {
      section: "Cultura",
      icon: "stream",
      title: "Cultura",
      scope: ["admin", "cultura"],
    },
    name: "cultura",
    meta: {
      isAuthenticated: true,
    },
  },
  {
    path: "/cultura/detail",
    component: ProcessDetail,
    name: "culturaProcessDetail",
    meta: {
      isAuthenticated: true,
    },
    // children: [],
  },

  {
    path: "/cultura/survey/:id",
    component: Survey,
    name: "culturaSurvey",
    meta: {
      isPublic: true,
    },
  },
  {
    path: "/cultura/share/:id/:filter",
    component: ShareCultura,
    name: "culturaShare",
    meta: {
      isPublic: true,
    },
  },
];



// WEBPACK FOOTER //
// ./src/components/cultura/routes.js